import { VueModule } from '@Foundation/utilities';
import HeaderBanner from './code/Scripts/components/header-banner';

export default VueModule({
  components: {
    HeaderBanner
  }
});
